import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_CANCEL_REQUEST, API_INITIATE_REQUEST, API_REQUEST, API_REQUEST_STEP, API_REQUEST_TYPES, API_REQUESTS_BY_STATUS} from '../../config/urls';
import {RequestTypeListDto} from '@dto/requests/request-type-list.dto';
import {RequestListDto} from '@dto/requests/request-list.dto';
import {InitiatedRequestDto} from '@dto/requests/initiated-request.dto';
import {UrlService} from '@shared/services/url.service';
import {RequestStatusEnum} from '@dto/requests/request-status.enum';
import {RequestDetailDto} from '@dto/requests/request-detail.dto';
import {RequestStepDetailDto} from '@dto/requests/request-step-detail.dto';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getRequestTypes(): Observable<RequestTypeListDto> {
    return this.http.get<RequestTypeListDto>(API_REQUEST_TYPES);
  }

  public initiateRequest(requestTypeId: string): Observable<InitiatedRequestDto> {
    const endpointUrl = this.urlService.buildUrl(API_INITIATE_REQUEST, requestTypeId);
    return this.http.post<InitiatedRequestDto>(endpointUrl, null);
  }

  public cancelRequest(requestId: string): Observable<void> {
    const endpointUrl = this.urlService.buildUrl(API_CANCEL_REQUEST, requestId);
    return this.http.post<void>(endpointUrl, null);
  }

  public getRequests(requestStatus: RequestStatusEnum): Observable<RequestListDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUESTS_BY_STATUS, requestStatus);
    return this.http.get<RequestListDto>(endpointUrl);
  }

  public getRequest(requestId: string): Observable<RequestDetailDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST, requestId);
    return this.http.get<RequestDetailDto>(endpointUrl);
  }

  public getRequestStep(requestId: string, stepId: number): Observable<RequestStepDetailDto> {
    const endpointUrl = this.urlService.buildUrl(API_REQUEST_STEP, requestId, String(stepId));
    return this.http.get<RequestStepDetailDto>(endpointUrl);
  }
}
